/**
 * Generated runtime TestId mirror for frontend/src/components/restriction-rules/TestResultsPanel.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const TestResultsPanelTestIds = {
  affectedIdentitiesDialog: "affected-identities-dialog",
  btnViewAffected: "btn-view-affected",
  cardTitleTestResults: "card-title-test-results",
  colName: "col-name",
  colParty: "col-party",
  colViolationIndicator: "col-violation-indicator",
  testResultsEmpty: "test-results-empty",
  testResultsError: "test-results-error",
  testResultsEvaluated: "test-results-evaluated",
  testResultsLoading: "test-results-loading",
  testResultsMatched: "test-results-matched",
  testResultsPanel: "test-results-panel",
  testResultsViolations: "test-results-violations",
  linkAffectedIdentity: (item_identity_id: string) => `link-affected-identity-${item_identity_id}`,
  linkAffectedIdentityPrefix: () => "link-affected-identity-" as TestIdPrefix,
  linkAffectedParty: (item_party_id: string) => `link-affected-party-${item_party_id}`,
  linkAffectedPartyPrefix: () => "link-affected-party-" as TestIdPrefix
} as const;
